import { Component, ViewChild, OnInit } from '@angular/core';
import { Sidebar } from 'primeng/sidebar';
import { SidebarMenuService } from '../../../../services/sidebar/sidebar-menu.service';
import { Permission } from '../../../../enums/permissions/Permission';
import { LoginService } from 'src/app/services/auth/login.service';
import { PrimeIcons } from 'primeng/api';
import { environment } from 'src/environments/environment';

type ApplicationModuleSlug = 'tes' | 'ems' | 'erp' | 'rum' | 'itrack' | 'pulse';

type ApplicationModuleLink = {
  role: string;
  displayName: string;
  routerLink: string;
};

@Component({
  selector: 'app-prime-sidebar-layout',
  templateUrl: './prime-sidebar-layout.component.html',
  styleUrls: ['./prime-sidebar-layout.component.css'],
})
export class PrimeSidebarLayoutComponent implements OnInit {
  @ViewChild('sidebarRef') sidebarRef!: Sidebar;
  isLoading: boolean = true;
  dropDownMenus: any[] = [];
  menus: any[] = [];
  applicationModules: ApplicationModuleLink[] = [];
  showModules: boolean = false;
  protected readonly Permission = Permission;
  currentAccount = JSON.parse(localStorage.getItem('account') || '{}');
  private readonly applicationModuleLinks: Record<
    ApplicationModuleSlug,
    ApplicationModuleLink
  > = {
    tes: {
      role: 'tes-user',
      displayName: 'Tes',
      routerLink: environment.tesUiUrl,
    },
    ems: {
      role: 'ems-user',
      displayName: 'EMS',
      routerLink: environment.emsUiUrl,
    },
    erp: {
      role: 'tes-admin',
      displayName: 'ERP Admin',
      routerLink: environment.erpUiUrl,
    },
    rum: {
      role: 'rum-user',
      displayName: 'RUM',
      routerLink: environment.rumUiUrl,
    },
    itrack: {
      role: 'itrack-user',
      displayName: 'iTrack',
      routerLink: environment.itrackUiUrl,
    },
    pulse: {
      role: 'pulse-user',
      displayName: 'Pulse',
      routerLink: environment.pulseUiUrl,
    },
  };

  constructor(
    private sidebarService: SidebarMenuService,
    private loginService: LoginService,
  ) {}

  ngOnInit(): void {
    this.getSidebarMenus();
    const decodedErpToken = this.loginService.decodeErpToken(
      this.loginService.getErpTokenFromCookie() ?? '',
    );
    const userRoles = this.splitCsv(decodedErpToken?.roles);
    const userModules = this.splitCsv(decodedErpToken?.applicationModules);

    if (userRoles?.includes('tes-admin')) {
      this.addApplicationModule(this.applicationModuleLinks.erp);
    }

    userModules.forEach((module) => {
      if (module === 'rum') return;
      const applicationModule = this.isApplicationModuleSlug(module)
        ? this.applicationModuleLinks[module]
        : null;
      if (applicationModule) this.addApplicationModule(applicationModule);
    });
  }

  getSidebarMenus() {
    this.isLoading = true;
    this.sidebarService
      .getSidebarMenus({ pageSize: 200 })
      .subscribe((res: any) => {
        this.isLoading = false;
        //if children is empty then it is a menu
        this.menus = res['value'].filter(
          (menu: any) => menu.children.length == 0,
        );
        //if children is not empty then it is a dropdown menu
        this.dropDownMenus = res['value'].filter(
          (menu: any) => menu.children.length > 0,
        );
      });
  }
  toggleMenu(event: Event): void {
    const arrowParent = (event.target as HTMLElement).parentElement
      ?.parentElement;
    if (arrowParent) {
      arrowParent.classList.toggle('showMenu');
    }
  }

  toggleModules(event: Event): void {
    event.stopPropagation();
    this.showModules = !this.showModules;
  }

  logout() {
    localStorage.clear();
    window.location.href = '/';
  }

  toggleSidebar(): void {
    this.sidebarService.toggleSidebar();
  }
  isSidebarClosed(): boolean {
    return this.sidebarService.getSidebarClosedStatus();
  }
  handleKeyDown(event: KeyboardEvent) {
    if (event.key === 'Enter' || event.key === ' ') {
      event.preventDefault();
      this.toggleSidebar();
    }
  }

  handleKeyDownLogout(event: KeyboardEvent) {
    if (event.key === 'Enter' || event.key === ' ') {
      event.preventDefault();
      this.logout();
    }
  }

  private splitCsv(value?: string): string[] {
    return Array.from(
      new Set(
        (value ?? '')
          .split(',')
          .map((item) => item.trim().toLowerCase())
          .filter(Boolean),
      ),
    );
  }

  private isApplicationModuleSlug(
    value: string,
  ): value is ApplicationModuleSlug {
    return value in this.applicationModuleLinks;
  }

  private addApplicationModule(applicationModule: ApplicationModuleLink): void {
    const exists = this.applicationModules.some(
      (module) => module.routerLink === applicationModule.routerLink,
    );
    if (!exists) this.applicationModules.push(applicationModule);
  }
}
